export default class CampaignOverview {
  constructor(el) {
    this.el = el;
    this.loadBtn = document.querySelector(".c-button--secondary");
    this.visibleCards = null;
    this.cardsSmall = null;
    this.cardsStanding = null;
    this.searchInput = "";
    this.clearIcon = null;
    this.init();
    this.initEvents();
  }

  init() {
    this.cardsSmall = Array.from(document.querySelectorAll(".c-card--small"));
    this.cardsStanding = Array.from(
      document.querySelectorAll(".c-card--standing")
    );
    if (this.cardsSmall.length > 6) {
      this.loadBtn.style.display = "block";
      this.visibleCards = this.cardsSmall.slice(0, 6);
    } else {
      this.visibleCards = this.cardsSmall;
    }
    let contentMobile = document.querySelector(
      ".c-campaign-overview__content-mobile"
    );

    if (contentMobile) {
      contentMobile.innerHTML = "";
      this.visibleCards.forEach((card) => {
        contentMobile.appendChild(card);
      });
      contentMobile.appendChild(this.loadBtn);
    }

    this.searchInput = document.querySelector(
      ".c-campaign-overview__search input"
    );
    this.clearIcon = document.querySelector(".c-input__right");
  }

  initEvents() {
    this.loadBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      this.loadMore();
    });

    this.searchInput?.addEventListener("input", (e) => {
      e.preventDefault();
      this.search(e.target.value);
    });

    this.clearIcon?.addEventListener("click", (e) => {
      e.preventDefault();
      this.search("");
    });
  }

  loadMore() {
    this.visibleCards = this.cardsSmall.slice(0, this.visibleCards.length + 6);
    let contentMobile = document.querySelector(
      ".c-campaign-overview__content-mobile"
    );
    contentMobile.innerHTML = "";
    this.visibleCards.forEach((card) => {
      contentMobile.appendChild(card);
    });
    if (this.visibleCards.length >= this.cardsSmall.length) {
      this.loadBtn.style.display = "none";
    }
  }

  search(input) {
    let contentMobile = document.querySelector(
      ".c-campaign-overview__content-mobile"
    );
    let contentDesktop = document.querySelector(
      ".c-campaign-overview__content-desktop"
    );
    contentMobile.innerHTML = "";
    contentDesktop.innerHTML = "";
    this.cardsSmall.forEach((card) => {
      if (
        card.querySelector(".c-card__content__title").innerText.includes(input)
      ) {
        contentMobile.appendChild(card);
      }
    });
    this.cardsStanding.forEach((card) => {
      if (
        card.querySelector(".c-card__content__title").innerText.includes(input)
      ) {
        contentDesktop.appendChild(card);
      }
    });
    if (this.visibleCards.length >= this.cardsSmall.length) {
      this.loadBtn.style.display = "none";
    }
  }
}
